import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { LocationSwitcher } from './LocationSwitcher';

export const Layout: React.FC = () => {
  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <div className="pt-16 md:pt-0">
          <LocationSwitcher />
        </div>
        <main id="main-content" className="flex-1 p-4 md:p-8 pb-24 md:pb-10 overflow-y-auto">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

